import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Pikorua } from "../components/Pikorua";
import { Input } from "../components/ui/input";

export default function Login() {
  const { user, login, checking } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (!checking && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  const field = "rounded-none border-white/20 bg-white/5 text-white h-12 placeholder:text-white/40 focus-visible:ring-2 focus-visible:ring-gold focus-visible:border-gold";

  return (
    <div className="min-h-screen bg-navy grid place-items-center relative overflow-hidden px-5" data-testid="login-page">
      <div className="absolute inset-0 noise-overlay" />
      <Pikorua className="absolute -right-20 -top-20 w-[500px] h-[500px] text-gold opacity-[0.06]" stroke="#F2A900" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative w-full max-w-md bg-navy-dark border border-white/10 p-8 md:p-10"
      >
        <Link to="/" className="text-gold text-sm uppercase tracking-[0.2em] hover:opacity-80">← Back to site</Link>
        <h1 className="font-heading text-4xl text-white font-medium mt-6 tracking-tight">Administration</h1>
        <p className="text-white/60 mt-2">Sign in to edit the website.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="text-sm text-white/70 mb-2 block">Email</label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@tmtt.co.nz" className={field} />
          </div>
          <div>
            <label className="text-sm text-white/70 mb-2 block">Password</label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={field} />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-gold text-navy font-semibold py-4 rounded-sm transition-transform hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
